export default __webpack_public_path__ + "static/bratz-game-mobile-1a3bc100e4fa1f0a68aa8c4cba8127a3.webp";